import {
	DataTableHeader,
	DataTableHeaderSort,
} from "@walmart-web/livingdesign-components"
import React, { useState } from "react"
import {
	ALIGNMENT_LEFT,
	ALIGNMENT_RIGHT,
	KEY_COLUMN_HEADER,
	SORTING_ASCENDING,
	SORTING_DESCENDING,
	VALUE_SORT_ASCENDING,
	VALUE_SORT_DESCENDING,
	WITHOUT_SORTING,
} from "../constants"
import "../index.scss"
import { DataHeaderProps } from "../interfaces"
import {
	isNecessaryConvert,
	sortToAscending,
	sortToDescending,
	validateShowOrHideArrow,
} from "../utils/utils"
import { DataTableHeaderAlignment } from "@walmart-web/livingdesign-components/DataTable/DataTableHeader"
import { concatClassNames } from "helpers/jsxHelpers"

const DataHeader: React.FC<DataHeaderProps> = ({
	columnsHeader,
	dataTable,
	defaultSorting,
	onSort,
}): JSX.Element => {
	const [columnOrderSortType, setColumnOrderSortType] = useState<
		DataTableHeaderSort
	>(SORTING_DESCENDING)
	const [columnToBeSorted, setColumnToBeSorted] = useState<string>(
		defaultSorting ?? ""
	)

	const handleSortDataTable = (hasSort = true, selectedColumn: string) => {
		if (!hasSort) {
			return
		}

		const isAnotherColumn = selectedColumn !== columnToBeSorted
		if (isAnotherColumn) {
			sortingDataTable(selectedColumn, sortToDescending, SORTING_DESCENDING)
			return
		}

		onChangeSorting(selectedColumn)
	}

	const sortingFunctions: Record<DataTableHeaderSort, (key: string) => void> = {
		ascending: (objectKey: string) =>
			sortingDataTable(objectKey, sortToDescending, SORTING_DESCENDING),
		descending: (objectKey: string) =>
			sortingDataTable(objectKey, sortToAscending, SORTING_ASCENDING),
		none: () => {},
	}

	const onChangeSorting = (idCol: string) =>
		sortingFunctions[columnOrderSortType](idCol)

	const sortingDataTable = (
		idCol: string,
		actionSorting: (
			firstValue: number | string,
			secondValue: number | string
		) => boolean,
		sort: DataTableHeaderSort
	) => {
		onSort(
			[...dataTable].sort((a, b) =>
				actionSorting(
					isNecessaryConvert(idCol, a[idCol]),
					isNecessaryConvert(idCol, b[idCol])
				)
					? VALUE_SORT_ASCENDING
					: VALUE_SORT_DESCENDING
			)
		)

		setColumnOrderSortType(sort)
		setColumnToBeSorted(idCol)
	}

	const getDataAlignment = (alignment: string): DataTableHeaderAlignment =>
		alignment === ALIGNMENT_LEFT ? ALIGNMENT_LEFT : ALIGNMENT_RIGHT

	const renderHeader = () => {
		return columnsHeader.map((columnHeader, index) => {
			const {
				name,
				alignment,
				nameColumnSort,
				hasSort,
				className,
				width,
			} = columnHeader

			const optionalSortProps = {
				...(hasSort && {
					sort: columnOrderSortType || WITHOUT_SORTING,
					onSort: () => handleSortDataTable(hasSort, nameColumnSort),
				}),
			}

			return (
				<DataTableHeader
					UNSAFE_className={concatClassNames([
						className,
						validateShowOrHideArrow(nameColumnSort, columnToBeSorted),
					])}
					key={`${KEY_COLUMN_HEADER}-${index}`}
					alignment={getDataAlignment(alignment)}
					width={width}
					{...optionalSortProps}
				>
					{name}
				</DataTableHeader>
			)
		})
	}

	return <>{renderHeader()}</>
}

export default DataHeader
